/* ===== NASHIRA PDP RUNTIME ===== */
(function(){
  'use strict';

  function money(cents, format){
    var f = format || window.NS_MONEY_FORMAT || 'Rs. {{amount}}';
    var amt = (cents/100);
    var withComma = amt.toLocaleString('en-IN', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    var noDecimal = Math.round(amt).toLocaleString('en-IN');
    return f
      .replace(/\{\{\s*amount\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimal)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimal);
  }

  function toast(msg){
    var t = document.getElementById('ns-toast');
    if(!t){
      t = document.createElement('div');
      t.id = 'ns-toast';
      t.style.cssText = 'position:fixed;bottom:90px;left:50%;transform:translateX(-50%) translateY(160px);background:#2a1810;color:#f7f0e4;padding:15px 30px;font-size:12px;letter-spacing:.14em;text-transform:uppercase;z-index:200;transition:.4s;border:1px solid #bf9b48;font-family:Mukta,sans-serif';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.style.transform = 'translateX(-50%) translateY(0)';
    clearTimeout(window._nstt);
    window._nstt = setTimeout(function(){ t.style.transform = 'translateX(-50%) translateY(160px)'; }, 2400);
  }

  function initPDP(root){
    var pdp = (root || document).querySelector('[data-ns-product]');
    if(!pdp) return;

    var moneyFormat = window.NS_MONEY_FORMAT;
    var dataScript = pdp.querySelector('[data-ns-product-json]');
    var variants = [];
    try {
      var parsed = JSON.parse(dataScript.textContent);
      variants = parsed.variants || [];
    } catch(e){ variants = []; }

    var form = pdp.querySelector('.ns-form-product');
    var idInput = pdp.querySelector('[data-ns-variant-id]');

    // Option groups are radio sets, one per product option
    var optGroups = Array.prototype.slice.call(pdp.querySelectorAll('[data-ns-option-index]'));

    function currentOptions(){
      return optGroups.map(function(group){
        var checked = group.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts){
      return variants.find(function(v){
        return opts.every(function(o, i){ return o == null || v.options[i] === o; });
      });
    }

    function updateOptionAvailability(){
      var opts = currentOptions();
      optGroups.forEach(function(group, gi){
        group.querySelectorAll('input[type="radio"]').forEach(function(input){
          var test = opts.slice();
          test[gi] = input.value;
          var match = variants.find(function(v){
            return test.every(function(o, i){ return o == null || v.options[i] === o; });
          });
          var label = input.closest('label') || input.parentNode;
          if(label) label.classList.toggle('ns-soldout', !(match && match.available));
        });
      });
    }

    // Read-only: move the carousel to the variant's image. Everything else
    // about variant state is ns-heritage.js's job.
    function syncGalleryToVariant(){
      var opts = currentOptions();
      var v = findVariant(opts);
      if(v && v.featured_media) showMedia(v.featured_media.id);
    }

    optGroups.forEach(function(group){
      group.addEventListener('change', function(e){
        if(e.target.matches('input[type="radio"]')) syncGalleryToVariant();
      });
    });

    // ---- gallery carousel ----
    var galTrack = pdp.querySelector('[data-ns-gal-track]');
    var galSlides = galTrack ? Array.prototype.slice.call(galTrack.querySelectorAll('.ns-gal__slide')) : [];
    var galThumbs = Array.prototype.slice.call(pdp.querySelectorAll('[data-ns-thumb]'));
    var galCounter = pdp.querySelector('[data-ns-gal-counter]');
    var galPrev = pdp.querySelector('[data-ns-gal-prev]');
    var galNext = pdp.querySelector('[data-ns-gal-next]');
    var galIndex = 0;

    function galSyncUI(i){
      galIndex = i;
      galSlides.forEach(function(s, n){ s.classList.toggle('ns-active', n === i); });
      galThumbs.forEach(function(t, n){
        var on = n === i;
        t.classList.toggle('ns-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        if(on && t.parentNode){
          var pr = t.parentNode.getBoundingClientRect();
          var tr = t.getBoundingClientRect();
          if(tr.left < pr.left || tr.right > pr.right){
            t.parentNode.scrollLeft += (tr.left - pr.left) - (pr.width / 2) + (tr.width / 2);
          }
        }
      });
      if(galCounter) galCounter.textContent = (i + 1) + ' / ' + galSlides.length;
      if(galPrev) galPrev.disabled = i <= 0;
      if(galNext) galNext.disabled = i >= galSlides.length - 1;
    }

    function galGoTo(i){
      if(!galTrack || !galSlides.length) return;
      i = Math.max(0, Math.min(galSlides.length - 1, i));
      galTrack.scrollTo({ left: galSlides[i].offsetLeft - galTrack.offsetLeft, behavior: 'smooth' });
      galSyncUI(i);
    }

    // keep showMedia() working for variant image swaps
    function showMedia(id){
      for(var n = 0; n < galSlides.length; n++){
        if(galSlides[n].getAttribute('data-ns-media-id') == id){ galGoTo(n); return; }
      }
    }

    if(galTrack && galSlides.length){
      var galTick;
      galTrack.addEventListener('scroll', function(){
        clearTimeout(galTick);
        galTick = setTimeout(function(){
          var mid = galTrack.scrollLeft + (galTrack.clientWidth / 2);
          var best = 0, bestDist = Infinity;
          galSlides.forEach(function(s, n){
            var c = s.offsetLeft - galTrack.offsetLeft + (s.offsetWidth / 2);
            var d = Math.abs(c - mid);
            if(d < bestDist){ bestDist = d; best = n; }
          });
          if(best !== galIndex) galSyncUI(best);
        }, 90);
      }, {passive:true});

      galThumbs.forEach(function(thumb, n){
        thumb.addEventListener('click', function(){ galGoTo(n); });
      });
      if(galPrev) galPrev.addEventListener('click', function(){ galGoTo(galIndex - 1); });
      if(galNext) galNext.addEventListener('click', function(){ galGoTo(galIndex + 1); });

      galTrack.addEventListener('keydown', function(e){
        if(e.key === 'ArrowRight'){ e.preventDefault(); galGoTo(galIndex + 1); }
        if(e.key === 'ArrowLeft'){ e.preventDefault(); galGoTo(galIndex - 1); }
      });

      var startIdx = 0;
      for(var gi = 0; gi < galSlides.length; gi++){
        if(galSlides[gi].classList.contains('ns-active')){ startIdx = gi; break; }
      }
      if(startIdx > 0){
        var prevBehavior = galTrack.style.scrollBehavior;
        galTrack.style.scrollBehavior = 'auto';
        galTrack.scrollLeft = galSlides[startIdx].offsetLeft - galTrack.offsetLeft;
        galTrack.style.scrollBehavior = prevBehavior;
      }
      galSyncUI(startIdx);
    }

    // Quantity stepper is bound by ns-heritage.js.

    // Add to cart, variant selection, price and the sticky bar are owned by
    // ns-heritage.js (NS.initProduct), which binds this same form. Duplicating
    // them here made one click POST to /cart/add.js twice.

    function refreshCartCount(){
      fetch('/cart.js', {headers:{'Accept':'application/json'}})
        .then(function(r){ return r.json(); })
        .then(function(cart){
          document.querySelectorAll('[data-ns-cart-count]').forEach(function(el){ el.textContent = cart.item_count; });
        }).catch(function(){});
    }

    // Sticky bar is bound by ns-heritage.js.

    // ---- buy it now -> GoKwik checkout ----
    // GoKwik checks out the cart, not a form, so the line has to be in the cart
    // before initCheckout is called. Buy Now means "just this piece", so the
    // cart is emptied first - the same thing snippets/gokwik-buy-now.liquid
    // already does on the other product templates. Using this form (rather than
    // a page-wide querySelector) is what keeps the selected variant and the
    // quantity stepper honest when related-product forms are also on the page.
    var buyNow = pdp.querySelector('[data-ns-buynow]');

    // Returns false when the SDK is not there yet, so the caller can fall back
    // to Shopify's checkout instead of leaving the shopper on a dead button.
    // The .ns-gokwik-open body class is owned by NS.watchGokwik in
    // ns-heritage.js, which watches for the modal on every entry point.
    function openGokwikCheckout(){
      try {
        if(window.gokwikSdk && typeof window.gokwikSdk.initCheckout === 'function' && window.merchantInfo){
          window.gokwikSdk.initCheckout(window.merchantInfo);
          return true;
        }
      } catch(e){}
      return false;
    }

    if(buyNow && form){
      var useGokwik = buyNow.hasAttribute('data-ns-gokwik');

      buyNow.addEventListener('click', function(){
        if(buyNow.classList.contains('is-loading')) return;
        buyNow.classList.add('is-loading');

        var ready = useGokwik
          ? fetch('/cart/clear.js', { method:'POST', headers:{'Accept':'application/json'} })
          : Promise.resolve();

        ready
          .then(function(){
            return fetch('/cart/add.js', { method:'POST', body:new FormData(form), headers:{'Accept':'application/json'} });
          })
          .then(function(r){ return r.json(); })
          .then(function(res){
            if(res.status){
              toast(res.description || 'Could not add to bag');
              buyNow.classList.remove('is-loading');
              return;
            }
            refreshCartCount();
            if(useGokwik && openGokwikCheckout()){
              buyNow.classList.remove('is-loading');
              return;
            }
            window.location.assign('/checkout');
          })
          .catch(function(){
            toast('Something went wrong');
            buyNow.classList.remove('is-loading');
          });
      });
    }

    // ---- trust row: draw the icons on when the row comes into view ----
    // Each path is measured so the dash animation runs its exact length -
    // a shared guess makes short paths finish early and long ones snap.
    // The row is fully drawn until .ns-trust--play is added, so if any of
    // this fails the icons are still there, just without the flourish.
    pdp.querySelectorAll('[data-ns-trust]').forEach(function(row){
      row.querySelectorAll('[data-ns-draw]').forEach(function(path){
        try {
          var len = path.getTotalLength();
          if (len && isFinite(len)) path.style.setProperty('--ns-len', Math.ceil(len));
        } catch(e){}
      });

      var play = function(){ row.classList.add('ns-trust--play'); };
      if(!('IntersectionObserver' in window)){ play(); return; }
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(!entry.isIntersecting) return;
          play();
          io.disconnect();
        });
      }, { threshold: 0.35 });
      io.observe(row);
    });

    // ---- offers: copy discount code ----
    pdp.querySelectorAll('[data-ns-copy-code]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var code = btn.getAttribute('data-ns-copy-code') || '';
        var label = btn.querySelector('[data-ns-copy-text]');
        var done = function(){
          btn.classList.add('ns-copied');
          if(label){
            var old = label.textContent;
            label.textContent = 'Copied';
            setTimeout(function(){ label.textContent = old; btn.classList.remove('ns-copied'); }, 1800);
          }
          toast('Code ' + code + ' copied ✦');
        };
        if(navigator.clipboard && navigator.clipboard.writeText){
          navigator.clipboard.writeText(code).then(done).catch(function(){});
        } else {
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.setAttribute('readonly', '');
          ta.style.position = 'absolute';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); done(); } catch(e){}
          document.body.removeChild(ta);
        }
      });
    });

    // ---- recently viewed: record this product ----
    try {
      var rvId = pdp.getAttribute('data-ns-product-id');
      if(rvId){
        var rvKey = 'ns:recently-viewed';
        var rvList = JSON.parse(localStorage.getItem(rvKey) || '[]');
        rvList = rvList.filter(function(x){ return String(x) !== String(rvId); });
        rvList.unshift(rvId);
        localStorage.setItem(rvKey, JSON.stringify(rvList.slice(0, 20)));
      }
    } catch(e){}

    // ---- live viewers ----
    var viewers = pdp.querySelector('[data-ns-viewers]');
    if(viewers){
      var base = parseInt(viewers.textContent,10) || 20;
      setInterval(function(){ viewers.textContent = (base - 5) + Math.floor(Math.random()*12); }, 4000);
    }

  }

  // ---- scroll-to-top CTA ----
  function initScrollTop(){
    document.querySelectorAll('[data-ns-scroll-top]').forEach(function(btn){
      btn.addEventListener('click', function(){ window.scrollTo({top:0, behavior:'smooth'}); });
    });
  }

  // ---- countdown ----
  function initCountdown(){
    // ns-heritage.js marks what it has bound; don't run a second timer on it
    document.querySelectorAll('[data-ns-countdown]:not([data-ns-bound])').forEach(function(el){
      var fixedEnd = el.getAttribute('data-ns-end');
      var hours = parseInt(el.getAttribute('data-ns-duration'),10) || 3;
      var target;
      if(fixedEnd){
        target = new Date(fixedEnd).getTime();
      } else {
        var key = 'ns_cd_' + location.pathname;
        var saved = localStorage.getItem(key);
        if(saved){ target = parseInt(saved,10); }
        else { target = Date.now() + hours*3600*1000; localStorage.setItem(key, target); }
        if(target < Date.now()){ target = Date.now() + hours*3600*1000; localStorage.setItem(key, target); }
      }
      var h = el.querySelector('[data-cd-h]'), m = el.querySelector('[data-cd-m]'), s = el.querySelector('[data-cd-s]');
      function tick(){
        var diff = Math.max(0, Math.floor((target - Date.now())/1000));
        var H = Math.floor(diff/3600), M = Math.floor((diff%3600)/60), S = diff%60;
        if(h) h.textContent = String(H).padStart(2,'0');
        if(m) m.textContent = String(M).padStart(2,'0');
        if(s) s.textContent = String(S).padStart(2,'0');
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  // ---- FAQ accordion ----
  function initFAQ(){
    document.querySelectorAll('[data-ns-faq-q]').forEach(function(q){
      q.addEventListener('click', function(){
        q.closest('.ns-faq-item').classList.toggle('ns-open');
      });
    });
  }

  function boot(){
    initPDP(document);
    initScrollTop();
    initCountdown();
    initFAQ();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function(e){
    initPDP(e.target); initScrollTop(); initCountdown(); initFAQ();
  });
})();
